var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItplogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 45.7",
    style: {
      enableBackground: "new 0 0 54 45.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.92,11.28c-3.4,3.82-5.54,9.47-5.54,15.78c0,8.15,3.59,15.21,8.82,18.63H4.59 c5.23-3.42,8.82-10.48,8.82-18.63c0-6.31-2.15-11.96-5.54-15.78H32.92L32.92,11.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.85,11.28c-3.4,3.82-5.54,9.47-5.54,15.78c0,8.15,3.59,15.21,8.82,18.63h-5.27 c-5.23-3.42-8.82-10.48-8.82-18.63c0-6.31,2.15-11.96,5.54-15.78H39.85L39.85,11.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.29,9.72C4.43,8.11,2.3,6.98,0,6.5h38.22L43.14,0h5.38L43.5,6.5H54c-2.3,0.48-4.43,1.61-6.29,3.23H6.29 L6.29,9.72z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItplogo);
export default __webpack_public_path__ + "static/media/itplogo.eac4d7111e2c6ad6e2028b2bb3e271eb.svg";
export { ForwardRef as ReactComponent };